import { createSlice } from "@reduxjs/toolkit";

const sessionSlice = createSlice({
  name: "session",
  initialState: {
    sessionResponse: null ,
    sessionId:null// Stores the full API response

  },
  reducers: {
    setSessionId: (state, action) => {
     
      state.sessionId = action.payload;

    },
    storeSessionResponse: (state, action) => {
     
      state.sessionResponse = action.payload;
    },
  },
});

export const selectSessionResponse = (state) => state.session.sessionResponse;
export const { setSessionId ,storeSessionResponse} = sessionSlice.actions;
export default sessionSlice.reducer;
